import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getCurrentUser } from 'aws-amplify/auth';

export const useRedirectIfAuthenticated = (redirectPath: string) => {
  const navigate = useNavigate();
  const [isCheckingAuth, setIsCheckingAuth] = useState(true);

  useEffect(() => {
    let active = true;

    const checkAuthentication = async () => {
      try {
        await getCurrentUser();
      } catch {
        if (active) {
          setIsCheckingAuth(false);
        }
        return;
      }

      if (!active) {
        return;
      }

      navigate(redirectPath, { replace: true });
    };

    void checkAuthentication();

    return () => {
      active = false;
    };
  }, [navigate, redirectPath]);

  return { isCheckingAuth };
};

export default useRedirectIfAuthenticated;
